import { addMethod, string } from 'yup';
import * as WAValidator from 'multicoin-address-validator';

const CURRENCY_NAME = 'matic';

addMethod(string, 'cryptoAddress', function (addressPath: string) {
  return this.test(addressPath, function () {
    const address = this.parent[addressPath];

    if (!WAValidator.validate(address, CURRENCY_NAME)) {
      throw this.createError({
        path: addressPath,
        message: `Please enter valid address`,
      });
    }

    return true;
  });
});
